/**
 * PublicTrackingPixel
 *
 * Invisible 1x1 tracking pixel for SuperSchema's AI Bot Analytics.
 * Only used on public-facing pages (not authenticated routes).
 *
 * Sends the current page URL and title to track which pages AI bots visit.
 */
import { useEffect } from 'react';

export function PublicTrackingPixel() {
  useEffect(() => {
    // Create and inject the tracking pixel with URL and title params
    const img = document.createElement('img');
    img.src = 'https://track.superschema.workers.dev/pixel/ugck4XYYxIKo?u=' +
      encodeURIComponent(window.location.href) +
      '&t=' +
      encodeURIComponent(document.title || '');
    img.width = 1;
    img.height = 1;
    img.style.cssText = 'position:absolute;left:-9999px;';
    img.alt = '';
    document.body.appendChild(img);

    // Cleanup on unmount
    return () => {
      if (img.parentNode) {
        img.parentNode.removeChild(img);
      }
    };
  }, []);

  return null;
}
